<template>
  <a :class="classes" href="javascript:void(0);" @click.prevent.stop="select">
    <span class="dn-radio-btn__faux"></span>
    <span class="dn-radio-btn__label" v-if="$slots.default"><slot /></span>
  </a>
</template>



<script>
export default {
  model: {
    prop: 'inputValue',
    event: 'change',
  },



  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    inputValue: {},
    value: {},
  },



  data() {
    return {
    }
  },



  computed: {
    classes() {
      return {
        'dn-radio-btn': true,
        'dn-radio-btn--checked': this.isActive,
        'dn-radio-btn--disabled': this.disabled,
      }
    },

    isActive() {
      return this.inputValue === this.value;
    },
  },



  methods: {
    select() {
      if (this.disabled) return;
      this.$emit('change', this.value);
    },
  },
}
</script>


// WEBPACK FOOTER //
// RadioBtn.vue?f9b8ec66